import { Store, UserSubscription } from '@griply/types';

export const isAppleSubscription = (subscription: UserSubscription) =>
  subscription.store === Store.Apple || subscription.store === Store.AppStore;
